import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=41fd6483&scoped=true"
import script from "./groups.vue?vue&type=script&lang=ts"
export * from "./groups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd6483",
  null
  
)

export default component.exports